import axiosInstance, { getAPIURL } from "../axiosInstance";

export interface PreviewWalletPricingRequest {
  userId: string;
  productId: string;
  discountCode?: string;
  isAnnual: boolean;
  isEvent: boolean;
  isEventEarlyBird: boolean;
  name?: string;
  email?: string;
}

export interface PreviewWalletPricingResponse {
  amountMinor: number;
  currency: string;
  noPaymentRequired: boolean;
  label: string;
  /** List price in minor units before membership promotion. */
  listAmountMinor?: number;
  /** List minus amount due today (membership promotion). */
  discountAmountMinor?: number;
  /** Stripe-derived terms (e.g. free for N months, then standard rate). */
  promotionSummary?: string;
}

export async function previewWalletPricing(
  body: PreviewWalletPricingRequest,
): Promise<PreviewWalletPricingResponse> {
  const res = await axiosInstance.post<PreviewWalletPricingResponse>(
    getAPIURL("/Payment/preview-wallet-pricing"),
    body,
  );
  return res.data;
}
